module.exports = "<div class=\"b-constructor__label\"><% print(lang(text)); %></div>"